'use strict';

/* global $ */

import { fancybox } from '../settings';


let settings = {
    linkSelector: '.js-toggle-content__link',
    fancybox: {},
};

class ToggleContent {
    constructor(options) {
        this.opt = $.extend({}, settings, options);
        this.init();
    }
    init() {
        console.log('[ ToggleContent/init ]');

        let $link = $(this.opt.linkSelector);

        $link.on('click', function(e) {
            e.preventDefault();

            let id = $(this).prop('rel'),
                $text = $('#' + id);

	        $.fancybox.open($.extend(true, {}, fancybox, {
	            type: 'html',
	            content: $text.html(),
	            touch: false,
	        }));
        });
    }
}


export {
    ToggleContent
};
